import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { API_ENDPOINTS } from '../../utils/config';

/** Module-level dedupe survives React StrictMode remounts in development. */
let lastRecordedPath = '';
let lastRecordedAt = 0;
const DEDUPE_MS = 1500;

/**
 * Fire a privacy-light pageview beacon on SPA route changes.
 * Counts document navigations / React Router path changes for all visitors
 * (logged-in and anonymous) — not API calls or static assets.
 */
function sendHit(path) {
    const payload = JSON.stringify({ path });
    try {
        if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
            const blob = new Blob([payload], { type: 'application/json' });
            if (navigator.sendBeacon(API_ENDPOINTS.PAGE_HIT, blob)) return;
        }
    } catch (_) {
        /* fall through to fetch */
    }
    fetch(API_ENDPOINTS.PAGE_HIT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
        credentials: 'omit',
    }).catch(() => {});
}

const PageHitTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // pathname only (ignore search/hash) so query tweaks do not inflate hits.
        const path = location.pathname || '/';
        const now = Date.now();
        if (path === lastRecordedPath && now - lastRecordedAt < DEDUPE_MS) return;
        lastRecordedPath = path;
        lastRecordedAt = now;
        sendHit(path);
    }, [location.pathname]);

    return null;
};

export default PageHitTracker;
